module.exports = __webpack_public_path__ + "img/love-paws-homestay-pet-grooming-bg.8beaba83.jpg";